import { Context } from '@leverege/plugin';
import { DataSources } from '@leverege/ui-attributes';
import { GlobalState } from '@leverege/ui-redux';
import I18N from '@leverege/i18n';
import LoadingView from "../../views/LoadingView.js";
const {
  t,
  tf,
  tIcon
} = I18N.ns('molten.imagine.map.MoveGeoPointAction');
const create = opts => {
  const {
    relationship,
    attribute
  } = opts;
  const {
    blueprint
  } = relationship;
  return {
    id: `blueprint.action.${blueprint.type}.MoveGeoPoint`,
    name: tf('name', {
      blueprintName: blueprint.name
    }),
    matches: {
      client: ['GoogleMapsRolloverSelectionPointer', 'MapBoxRolloverSelectionPointer'],
      use: 'contextMenu'
    },
    handles: cxt => {
      return cxt.mapViewer != null && (cxt.event?.lngLat != null || cxt.event?.srcEvent?.latLng != null) &&
      // Context.getTargets( cxt ).length === 0 &&
      Context.isSecondaryTargetOfType(cxt, blueprint.type);
    },
    appearance: () => {
      return {
        name: t('name', {
          blueprintName: blueprint.name
        }),
        icon: tIcon('arrowIcon', 'fa fa-arrows fa-fw')
      };
    },
    perform: props => {
      const {
        context
      } = props;
      const tgt = Context.getSecondaryTargetOfType(context, blueprint.type);
      const delegate = DataSources.getActions(tgt);
      const position = {};
      if (context.event?.srcEvent?.latLng) {
        position.lat = context.event.srcEvent.latLng.lat();
        position.lng = context.event.srcEvent.latLng.lng();
      } else if (context.event?.lngLat) {
        position.lat = context.event.lngLat.lat;
        position.lng = context.event.lngLat.lng;
      }
      const {
        lng: lon,
        lat
      } = position;
      const update = {
        data: []
      };
      update.data.push({
        path: attribute.path,
        value: {
          lat,
          lon
        }
      });
      const close = LoadingView.showDialog(t('savingDialog', {
        blueprintName: blueprint.name
      }));
      GlobalState.dispatch(delegate.update(update)).then(() => {}, console.log) // eslint-disable-line no-console
      .then(close);
    }
  };
};
export default {
  create
};